import {useState, Fragment, useEffect, useRef} from 'react';
import {MdUnarchive} from 'react-icons/md';
import {ContentHeader, DatePicker} from '@app/components';
import {getAllTodos, unArchiveTodo, indexHandler} from '@app/services/todos';
import {logoutUser} from '@app/store/reducers/auth';
import {useDispatch, useSelector} from 'react-redux';
import handleStatus from '../../utils/ajax';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import Pagination from '../../components/pagination/index';
import {format} from 'date-fns';

const Archives = () => {
  const [archived, setArchived] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const childRef = useRef();
  const [title, setTitle] = useState('');
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState();
  const [reload, setReload] = useState(false);

  const myArchived = async (query: any) => {
    const resp = await getAllTodos(query);
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
    if (resp.status === 200) {
      setArchived(resp.data.data);
      setTotalRecords(resp.data.totalRecords);
    }
  };

  const unArchiveHandler = async (id: any) => {
    const resp = await unArchiveTodo(id);
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
    if (resp.status === 200) {
      toast.success('UnArchived Successfully');
      const updated = indexHandler(archived, id);
      setArchived(updated);
    }
  };

  const handleCustomDateChange = ({startDate, endDate}) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const filter = async () => {
    const result = await getAllTodos({
      startDate: startDate,
      endDate: endDate,
      searchText: title,
      isArchieved: true
    });
    if (result.status === 200) {
      setArchived(result.data.data);
    }
  };

  const paginate = (pageno) => {
    myArchived({startDate, endDate, isArchieved: true, pageNo: pageno});
    setCurrentPage(pageno);
  };

  const reset = () => {
    setTitle('');
    setStartDate(0);
    setEndDate(0);
    childRef.current.resetDatePicker();
    setReload(!reload);
  };

  const readableDateMaker = (date: any) => {
    const readableDate = format(date, 'dd/MM/yyyy');
    return readableDate;
  };

  const priortyStyler = (priority: any) => {
    if (priority === 'low') {
      return (
        <span
          style={{borderRadius: '4px'}}
          className="text-uppercase bg-success p-2 mx-2"
        >
          {priority}
        </span>
      );
    }

    if (priority === 'medium') {
      return (
        <span
          style={{borderRadius: '4px'}}
          className="text-uppercase bg-warning p-2 mx-2"
        >
          {priority}
        </span>
      );
    }
    if (priority === 'urgent') {
      return (
        <span
          style={{borderRadius: '4px'}}
          className="text-uppercase bg-danger p-2"
        >
          {priority}
        </span>
      );
    }
  };

  useEffect(() => {
    myArchived({isArchieved: true});
  }, [reload]);

  const path = localStorage.getItem('Path');
  const pageNo = localStorage.getItem('PageNo');

  useEffect(() => {
    if (path === 'archive' && pageNo !== 1) {
      setCurrentPage(pageNo);
      myArchived({isArchieved: true, pageNo: pageNo});
    } else {
      localStorage.setItem('Path', 'archive');
      localStorage.setItem('PageNo', currentPage);
      myArchived({isArchieved: true});
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('PageNo', currentPage);
  }, [currentPage]);

  return (
    <Fragment>
      <ContentHeader title="My Archived" />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div className="card-header d-flex p-2">
                <div className="col-xl">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Title"
                    onChange={(e) => setTitle(e.target.value)}
                    value={title}
                  />
                </div>

                <div className="col-xl">
                  <div className="form-group m-0">
                    <DatePicker
                      ref={childRef}
                      onSelect={handleCustomDateChange}
                    />
                  </div>
                </div>

                <div className="col-md-1">
                  <Button variant="primary" onClick={filter}>
                    Search
                  </Button>
                </div>
                <div className="col-md-1 caseResetButton">
                  <Button variant="primary" onClick={reset}>
                    Reset
                  </Button>
                </div>
              </div>
            </div>
            {archived.length === 0 ? (
              <h1 style={{padding: '5rem'}} className="text-center">
                No Archive Found
              </h1>
            ) : (
              <div className="card-body">
                <div className="card m-0">
                  <table className="table table-hover text-nowrap">
                    <thead>
                      <tr
                        className="row px-2"
                        style={{
                          display: 'flex',
                          alignItems: 'stretch',
                          justifyContent: 'space-around',
                          width: '100%'
                        }}
                      >
                        <th className="text-left col-sm ">Content</th>
                        <th
                          style={{width: '100px'}}
                          className="text-center col-xs"
                        >
                          Priority
                        </th>
                        <th
                          style={{width: '100px'}}
                          className="text-center col-xs"
                        >
                          Expiry Date
                        </th>
                        <th
                          style={{width: '100px'}}
                          className="text-center col-xs"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {archived.map((todo: any, idx) => (
                        <tr
                          key={idx}
                          className="row m-0 p-0"
                          style={{
                            display: 'flex',
                            alignItems: 'stretch',
                            justifyContent: 'space-around',
                            width: '100%'
                          }}
                        >
                          <td className="col-xl" style={{maxWidth: '635px'}}>
                            <p
                              className="text-break"
                              style={{
                                overflowWrap: 'break-word',
                                whiteSpace: 'normal'
                              }}
                            >
                              {todo.text}
                            </p>
                          </td>

                          <td
                            style={{width: '100px'}}
                            className="text-center col-xs d-flex align-items-center"
                          >
                            {todo.priority
                              ? priortyStyler(todo.priority)
                              : 'N/A'}
                          </td>
                          <td
                            style={{width: '100px'}}
                            className="text-center  text-wrap col-xs d-flex align-items-center"
                          >
                            {todo.expiryDate
                              ? readableDateMaker(todo.expiryDate)
                              : 'N/A'}
                          </td>
                          <td
                            style={{width: '100px'}}
                            className="text-center col-xs d-flex align-items-center"
                          >
                            <MdUnarchive
                              onClick={() => unArchiveHandler(`${todo?._id}`)}
                              title={'UnArchive'}
                              style={{
                                fontSize: '20px',
                                marginLeft: '4px',
                                cursor: 'pointer',
                                color: 'green'
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      {archived.length === 0 ? (
        ''
      ) : (
        <Pagination
          postsPerPage={postPerPage}
          totalPosts={totalRecords}
          paginate={paginate}
          currentPage={currentPage}
        />
      )}
    </Fragment>
  );
};

export default Archives;

/*

<tr key={idx} className="row  m-0 p-0">
                        <td className="text-left col-sm text-left">
                          {todo.text}
                        </td>
                        <td
                          style={{ width: '100px' }}
                          className="text-center col-xs "
                        >
                          {todo.priority ? priortyStyler(todo.priority) : 'N/A'}
                        </td>
                        <td
                          style={{ width: '100px' }}
                          className="text-center  text-wrap col-xs "
                        >
                          <span>
                            {todo.expiryDate
                              ? readableDateMaker(todo.expiryDate)
                              : 'N/A'}
                          </span>
                        </td>
                        <td
                          style={{ width: '100px' }}
                          className="text-center col-xs "
                        >
                          <MdUnarchive
                            onClick={() => unArchiveHandler(`${todo?._id}`)}
                            title={'UnArchive'}
                            style={{
                              fontSize: '20px',
                              marginLeft: '4px',
                              cursor: 'pointer',
                              color: 'green'
                            }}
                          />
                        </td>
                      </tr>

*/
